import { render, staticRenderFns } from "./gj-category-select.vue?vue&type=template&id=8064cff6&scoped=true&"
import script from "./gj-category-select.vue?vue&type=script&lang=js&"
export * from "./gj-category-select.vue?vue&type=script&lang=js&"
import style0 from "./gj-category-select.vue?vue&type=style&index=0&id=8064cff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8064cff6",
  null
  
)

export default component.exports